export default __webpack_public_path__ + "static/media/illustration10-min.91d31d35.webp";